import React from 'react';
import './Steps.css';

const Projects = ({ formData, setFormData, language = 'fr' }) => {
  const t = {
    title: language === 'fr' ? 'Projets Académiques' : 'Academic Projects',
    itemTitle: (i) => language === 'fr' ? `Projet ${i + 1}` : `Project ${i + 1}`,
    nameLabel: language === 'fr' ? 'Nom du projet *' : 'Project Name *',
    namePlaceholder: language === 'fr' 
      ? 'Application de gestion e-learning'
      : 'E-learning Management App',
    dateLabel: language === 'fr' ? 'Date *' : 'Date *',
    datePlaceholder: language === 'fr' ? 'Novembre 2023' : 'November 2023',
    techLabel: language === 'fr' ? 'Technologies *' : 'Technologies *',
    techPlaceholder: language === 'fr' ? 'Java, JavaFX' : 'Java, JavaFX',
    descLabel: language === 'fr' ? 'Description *' : 'Description *',
    descPlaceholder: language === 'fr'
      ? "Développement d'une plateforme de gestion d'e-learning avec gestion des cours, utilisateurs et suivi des progrès."
      : "Development of an e-learning platform with course, user, and progress tracking management.",
    removeBtn: language === 'fr' ? 'Supprimer' : 'Remove',
    addBtn: language === 'fr' ? '+ Ajouter un projet' : '+ Add Project'
  };

  const handleProjectChange = (index, field, value) => {
    const newProjects = [...formData.projects];
    newProjects[index][field] = value;
    setFormData(prev => ({ ...prev, projects: newProjects }));
  };

  const addProject = () => {
    setFormData(prev => ({
      ...prev,
      projects: [...prev.projects, { name: '', date: '', technologies: '', description: '' }]
    }));
  };

  const removeProject = (index) => {
    const newProjects = formData.projects.filter((_, i) => i !== index);
    setFormData(prev => ({ ...prev, projects: newProjects }));
  };

  return (
    <div className="step-content">
      <h2>{t.title}</h2>
      
      {formData.projects.map((project, index) => (
        <div key={index} className="form-item">
          <div className="item-header">
            <h3>{t.itemTitle(index)}</h3>
            <button type="button" className="remove-btn" onClick={() => removeProject(index)}>
              {t.removeBtn}
            </button>
          </div>

          <div className="form-grid">
            <div className="input-group">
              <label>{t.nameLabel}</label>
              <input
                type="text"
                value={project.name}
                onChange={(e) => handleProjectChange(index, 'name', e.target.value)}
                placeholder={t.namePlaceholder}
                required
              />
            </div>

            <div className="input-group">
              <label>{t.dateLabel}</label>
              <input
                type="text"
                value={project.date}
                onChange={(e) => handleProjectChange(index, 'date', e.target.value)}
                placeholder={t.datePlaceholder}
                required
              />
            </div>

            <div className="input-group full-width">
              <label>{t.techLabel}</label>
              <input
                type="text"
                value={project.technologies}
                onChange={(e) => handleProjectChange(index, 'technologies', e.target.value)}
                placeholder={t.techPlaceholder}
                required
              />
            </div>

            <div className="input-group full-width">
              <label>{t.descLabel}</label>
              <textarea
                value={project.description}
                onChange={(e) => handleProjectChange(index, 'description', e.target.value)}
                placeholder={t.descPlaceholder}
                rows="3"
                required
              />
            </div>
          </div>
        </div>
      ))}

      <button type="button" className="add-btn" onClick={addProject}>
        {t.addBtn}
      </button>
    </div>
  );
};

export default Projects;